import clsx from 'clsx'
import Image from 'next/image'

import Link from '@/atoms/Link/Link'

/* assets */
import { ReactComponent as ArrowRight } from 'public/assets/pepper-chat/icons/arrow-down.svg'

interface Props {
  title: string
  sampleList: {
    id: string | number
    colorOne?: string
    colorTwo?: string
    title: string
    description: string
    image?: StrapiImageFile
  }[]
}

function Samples({ title, sampleList }: Props) {
  return (
    <section className="font-heading text-blue-web-90">
      <div className="container | py-10 md:py-18">
        <h2
          className="text-3xl lg:text-5xl font-medium | mb-10 md:mb-12"
          dangerouslySetInnerHTML={{ __html: title }}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-7 | mb-10">
          {sampleList.map(item => {
            const gradientStyle = {
              background: `linear-gradient(to bottom, ${item.colorOne}, ${item.colorTwo})`
            }
            return (
              <div
                key={item.id}
                className={clsx(
                  `flex flex-col justify-between gap-10 md:gap-8 shadow-md hover:shadow-lg transition-all duration-200 ease-in | border border-gray-30 rounded-xl | group p-8 md:p-9`
                )}
                style={gradientStyle}
              >
                {item.image?.url ? (
                  <div className="mb-6 md:mb-5">
                    <Image
                      src={item.image.url}
                      alt={item.image.alternativeText ?? ''}
                      width={item.image.width}
                      height={item.image.height}
                      className="max-w-col-3"
                    />
                  </div>
                ) : (
                  <div className="h-12 mb-7 md:mb-8" />
                )}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-end h-44">
                  <div className="text-2xl md:text-3xl text-white font-medium">
                    <p dangerouslySetInnerHTML={{ __html: item.title ?? '' }} />
                  </div>
                  <Image
                    src="/assets/icons/overview/circular-right.svg"
                    alt=""
                    width={48}
                    height={48}
                    className="ml-auto group-hover:-rotate-45 transition-all ease-out"
                  />
                </div>
              </div>
            )
          })}
        </div>
        <Link
          href="/samples/"
          target="_blank"
          className={clsx(
            'font-body flex justify-center items-center text-blue-web-50 | border border-blue-web-50 rounded px-4 py-2 | w-full md:max-w-col-3 md:mx-auto'
          )}
        >
          View our samples page
          <ArrowRight className="ml-2 -rotate-90" />
        </Link>
      </div>
    </section>
  )
}

export default Samples
